export default __webpack_public_path__ + "images/phone.68d2ea216fbe60c027278ca476e708ca.svg";